<template>
  <div>
    <div>
      <div>{{form.examineeName}} | {{form.examineIdNo}} | {{form.agentName}} | {{$enums.examStatus[form.status]}}</div>
      <div>账号：{{form.account}}</div>
      <div>{{form.batchName}} {{form.categoryName}} {{form.special}} {{form.gradeName}}</div>
      <div>考试开始时间：{{form.signTime?$moment(form.signTime).format('YYYY-MM-DD HH:mm:ss'):''}}</div>
    </div>
    <div v-if="form.isAllowRedo">
      <el-table :data="form.subjectList" :max-height="330" stripe size="medium">
        <el-table-column prop="subjectName" label="科目名称"></el-table-column>
        <el-table-column prop="redoNumber" label="重考次数">
          <template>
            {{form.redoNumber}}
          </template>
        </el-table-column>
        <el-table-column prop="newRecordTime" label="最新一次录制时间">
          <template slot-scope="scope">
            {{scope.row.newRecordTime? $moment(scope.row.newRecordTime).format('YYYY-MM-DD HH:mm:ss') : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="isCommit" label="提交次数">
          <template slot-scope="scope">
            {{scope.row.isCommit}}
          </template>
        </el-table-column>
        <el-table-column prop="isCommit" label="是否提交">
          <template slot-scope="scope">
            {{$enums.boolean[scope.row.isCommit]}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <el-table :data="form.subjectList" :max-height="330" stripe size="medium">
        <el-table-column prop="subjectName" label="科目名称"></el-table-column>
        <el-table-column prop="recordNumber" label="录制次数"></el-table-column>
        <el-table-column prop="newRecordTime" label="最新一次录制时间">
          <template slot-scope="scope">
            {{scope.row.newRecordTime? $moment(scope.row.newRecordTime).format('YYYY-MM-DD HH:mm:ss') : ''}}
          </template>
        </el-table-column>
        <el-table-column prop="isCommit" label="是否提交">
          <template slot-scope="scope">
            {{$enums.boolean[scope.row.isCommit]}}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-right" style="margin-top: 50px;">
      <el-button size="medium" @click="$emit('close', false)">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {}
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        let info = await this.$HTTP.ApiCommon.getDetail(this.row.examId)
        this.form = info
      }
    }
  }
}
</script>
